export const FIREBASE_CONFIG = {
    apiKey: "AIzaSyAiMCkT369sFNfC4PVkHJtLpAq5x0FBdZw",
    authDomain: "ajuntamentdeltebre.firebaseapp.com",
    databaseURL: "https://ajuntamentdeltebre.firebaseio.com",
    projectId: "ajuntamentdeltebre",
    storageBucket: "ajuntamentdeltebre.appspot.com",
    messagingSenderId: "416311749184"
};


// WEBPACK FOOTER //
// ./src/app/app.firebase.config.ts